import React, { useEffect, useState } from "react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import CommonDatePicker from "../../../components/CommonDatePicker";
import SelectBox from "../../../components/SelectBox";
import { companyDetails, siteDetails } from "../../redux/api/dummyJson";
import { knf_logo } from "../../../assets/imgs";
import AlertBarChart from "../../../components/chart/AlertBarChart";
import ChartTable from "../../../components/chart/ChartTable";
import DateBarChart from "../../../components/chart/DateBarChart";
//  import DonutChart from "../../../components/chart/DonutChart";
import PieChart from "../../../components/PieChart";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import ConsolidatedReport from "./ConsolidatedReport";

const SiteReport = () => {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  const [siteData, setSiteData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [reportData, setReportData] = useState({});

  const location = useLocation();
  const type = location?.state?.type;

  const data = location.state?.data;

  const createdAt = moment().format("DD-MM-YYYY");
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
        setSiteList([]);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company_id) => {
    let formdata = new FormData();
    setSelectedCompany(company_id);
    formdata.append("company_id", company_id?.value);
    post(URL.ACTIVE_ADMIN_SITE, formdata)
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        } else {
          setSiteList([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  console.log("selectedCompany", selectedCompany);

  const handlePreview = () => {
    let formdata = new FormData();
    formdata.append("from_date", moment(fromDate).format("YYYY-MM-DD"));
    formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    formdata.append("site_id", selectedOption?.value);
    post(URL.GET_CONSOLIDATED_REPORT_ADMIN, formdata)
      .then((res) => {
        if (res?.data) {
          setReportData(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Site"} type={"Report"} hide={!type} />

      {type && (
        <div className="d-flex p-1">
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Company Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${data?.companyName ?? "Ninos"} - ${
                  data?.companyId ?? "N001"
                }`}
              />
            </div>

            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${data?.siteName ?? "Robotics"} - ${
                  data?.siteCode ?? "R001"
                }`}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Location
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={data?.siteLocation ?? "Chennai,vadapalani"}
              />
            </div>
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Admin
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={data?.siteAdminName ?? "Shakthivel"}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Admin Created On
              </p>
              <input className="input-box w-100" readOnly value={createdAt} />
            </div>
          </div>
        </div>
      )}

      {type && (
        <div className="col-md-12 p-3 d-flex ac-js gap-5">
          <div className="p-2 mb-2">
            <button className="submit-btn">View Report</button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-notifications", {
                  state: {
                    data: data,
                    type: "site-view",
                  },
                })
              }
            >
              View Notifications
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-slot-main", {
                  state: { type: "site-view", data: data, superAdmin: true },
                })
              }
            >
              View slot days
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-alert-types", {
                  state: {
                    type: "site-view",
                    data: data,
                  },
                })
              }
            >
              Alert Types
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-cameras", {
                  state: {
                    type: "site-view",
                    data: data,
                  },
                })
              }
            >
              Cameras
            </button>
          </div>
        </div>
      )}

      <div className={`d-flex ${type ? "gap-5" : "ac-jb"}`}>
        {/* Company Select */}
        {!type && (
          <div className="col-md-2">
            <label className="form-label">Select Company</label>
            <SelectBox
              arrayData={comapanyList}
              data={company}
              setData={setCompany}
              selectedOption={selectedCompany}
              setSelectedOption={getSiteList}
              style={true}
            />
          </div>
        )}

        {/* Site Select */}
        {!type && (
          <div className="col-md-2">
            <label className="form-label">Select Site</label>
            <SelectBox
              arrayData={siteList}
              data={siteData}
              setData={setSiteData}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              disabled={selectedCompany?.label ? false : true}
              style={true}
            />
          </div>
        )}

        <CommonDatePicker
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        {/* Preview Button */}
        <div className="col-md-1 mt-4">
          <button
            onClick={handlePreview}
            className="submit-btn"
            disabled={
              !fromDate ||
              !toDate ||
              !selectedCompany?.label ||
              !selectedOption?.label
            }
          >
            Preview
          </button>
        </div>
      </div>

      {/* second section */}

      {/* download btn */}
      {reportData?.company && <ConsolidatedReport data={reportData} />}
    </div>
  );
};

export default SiteReport;
